<template>
    <div>
        <hts-form-autocomplete
            v-model="driverId"
            :label="$t('labels.driver')"
            :required="required"
            :server="serverDriver"
            :text="driverName"
            :placeholder="$t('labels.driverModule.chooseDriver')"
            :permissions-add="layoutPermissions.driver_add"
            key-id="_id"
            key-label="driverDetail"
            @add="showSlideOverAddDriver = true"
            @change="(data:any)=>handleChange(data)" />

        <add-driver
            :show="showSlideOverAddDriver"
            @close="showSlideOverAddDriver = false"
            @new-driver="(driver) => newDriver(driver)" />
    </div>
</template>
<script lang="ts" setup>
import AddDriver from '../../driver/ignore/add-driver.vue'
import layoutPermissions from '@/data/permissions/layout-permissions'

const props = defineProps({
  required: {
    type: Boolean,
    default: false
  },
  driverIsSelected: {
    type: Object,
    default: () => {}
  },
  driverName: {
    type: String,
    default: ''
  }
})
const driverId = ref('')
const driverName = ref('')
const serverDriver = $url.driver.driver.select
const showSlideOverAddDriver = ref(false)
const emits = defineEmits(['changeInput'])

watch(props, () => {
  if (props.driverName) {
    driverName.value = props.driverName
  }
})

const newDriver = (driver: any) => {
  driverName.value = driver.fullName
  driverId.value = driver.code
}

const handleChange = (data: any) => {
  emits('changeInput', data)
}
</script>
